import { Component, Inject, Optional } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface UsersData {
  name: string;
  id: number;
}

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  action: string;
  local_data: any;
  msg: string;
  title: string;
  btn1Action: string;
  btn2Action: string;
  btnAction: string;
  showChancel: boolean;

  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData,
    @Optional() @Inject(MAT_DIALOG_DATA) public message: string) {
    this.local_data = {...data};
    this.action = this.local_data.dataObj.action;
    this.title = this.local_data.title;
    this.msg = this.local_data.message;
    this.btnAction = this.local_data.btn1Action;
    this.btn1Action = this.btnAction == null ? 'Delete' : this.btnAction;
    this.btn2Action = 'Cancel';
    this.showChancel = true;
  }

  closeDialog(action) {
    this.dialogRef.close({event: action, data: this.local_data});
  }

}
